import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalDisease = () => {

return(
<div>
    
<Typography variant="h6" >

Association of genetic polymorphisms of the lipoprotein important regulatory genes Niemann-Pick C1-like 1 (NPC1L1) and 3-hydroxy-3-methylglutaryl-coenzyme A reductase (HMGCR) 
in patients with premature triple-vessel coronary disease (PTVD) with diabetes, blood glucose and body mass index. 
<br /><br /> 
HMGCR rs2303151 -- is a novel polymorphism of the HMGCR gene related to the risk of diabetes in PTVD (premature triple-vessel coronary disease) patients, 
which suggests HMGCR may be a potential common targeted pathogenic pathways between coronary heart disease and diabetes.
<br /><br /> 
# 
NPC1L1 rs4720470 -- rs4720470 on NPC1L1 gene and rs2303151 on HMGCR gene were associated with risk of 1-year MACCE (ajor Adverse Cardiac and Cerebrovascular Events) in TVD (Three-Vessel Disease)<br /> 
# Three-vessel disease (TVD) is a severe coronary heart disease (CHD) with poor prognosis. <br /> 
# Niemann-Pick C1-like 1 (NPC1L1) is a transporter protein for exogenous cholesterol absorption, and 3-hydroxy-3-methylglutaryl-coenzyme A reductase (HMGCR) is a rate-limiting enzyme for cholesterol synthesis.
<br /><br /> 
HMGCR rs12916 genotype C/C --  
# We first reported that the variant homozygous CC of rs12916 within HMGCR gene may incur a significantly higher risk of RCR in PTVD patients treated with statins, 
providing new insights into early individualized guidance of precise lipid-lowering treatment.<br /> 
# RCR (residual cholesterol risk) was defined as achieved low-density lipoprotein cholesterol (LDL-C) concentrations after statins higher than 1.8 mmol/L (70 mg/dL).
<br /><br /> 
HMGCR NPC1L1 Polymorphism  -  <br />
# HMGCR and NPC1L1 gene polymorphisms were associated with inflammatory biomarkers in patients with PTVD (premature three-vessel disease), providing new insights in mechanism of correlation between lipid and inflammation
<br /> <br />
APOA5 rs2266788	
# causal association between triglyceride-mediated pathways and coronary heart disease
<br /><br /> 
# Alcohol, Carbohydrate, and Calcium Intakes and Smoking Interactions with APOA5 rs662799 and rs2266788 were Associated with Elevated Plasma Triglyceride Concentrations in a Cross-Sectional Study of Korean Adults  <br /> 
# Info: Apolipoprotein E (ApoE) and solute carrier organic anion transporter family member 1B1 (SLCO1B1) regulate lipid metabolism.
<br /><br /> 

gene SCN5A, sodium voltage-gated channel alpha subunit 5 <br />
# variant rs1805124, heterozygote genotype T/C -- H558R -- clinvar Benign/Likely benign  -  quite common, seems to be considered to be a benign change  <br /> 
# -- Primary dilated cardiomyopathy, Congenital long QT syndrome, Dilated cardiomyopathy 1E, Cardiac arrhythmia, ... <br /> 
# -- together with another variant as haplotype on SCN5A (Chr3:38,604,067)  -- Progressive familial heart block, type 1A  <br /> 
#  Association of SCN5A gene polymorphism with dilated cardiomyopathy   
<br /><br /> 
CHRNA5 - rs16969968  -- slightly higher risk for nicotine dependence, lower risk for cocaine dependence<br /> 
# rs1051730 -- when smoking -- 1.3x increased risk of lung cancer, reduced response to alcohol, therefore possibly increased risk of alcohol abuse -- <br /> 
# Chromosome 15q25.1 genetic markers associated with level of response to alcohol in humans - 

<br /><br /> <br /><br /> 

Sources: <br /><br />
https://pubmed.ncbi.nlm.nih.gov/35998373/   <br />
https://pubmed.ncbi.nlm.nih.gov/33167740/ <br />
https://bmccardiovascdisord.biomedcentral.com/articles/10.1186/s12872-023-03285-w  <br />
https://www.jacc.org/doi/10.1016/S0735-1097%2822%2902003-4   <br />
https://pubmed.ncbi.nlm.nih.gov/20452521/<br />
https://www.clinicalkey.com/nursing/#!/content/playContent/1-s2.0-S2212267220300630?returnurl=null&referrer=null  <br />
https://pubmed.ncbi.nlm.nih.gov/18378609/ <br />
https://academic.oup.com/ehjacc/article/10/Supplement_1/zuab020.011/6252146 <br />
https://pubmed.ncbi.nlm.nih.gov/19064933/ <br />
<br />

 
</Typography>

</div>
)
}